import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getIsUserSubscribed, getPrimaryTier, } from '../../DeviationViews/_helpers';
import { useIsCurrentUserDeviationAuthor } from './useIsCurrentUserDeviationAuthor';
/** returns member subscription info for the given deviation */
export function useSubscriptionTier(deviation) {
    var member_subscriptions = useFlag('member_subscriptions');
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var tier = getPrimaryTier(deviation);
    var isUserSubscribed = getIsUserSubscribed(deviation);
    var subscriptionsMatter = member_subscriptions && !isOwner;
    var isBlockedBySubscription = !!tier && !isUserSubscribed;
    return {
        tier: tier,
        isOwner: isOwner,
        isUserSubscribed: isUserSubscribed,
        isBlockedBySubscription: subscriptionsMatter && isBlockedBySubscription,
    };
}
//# sourceMappingURL=useSubscriptionTier.js.map